var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"stt":"true","columns":_vm.columnsClient,"rows":_vm.data_success}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }